import type { CheatsheetCtx } from "./types";

/**
 * Replace `<TOKEN>` placeholders in a command string with real values from
 * the current card's context. Unknown tokens stay uppercase so the user
 * knows to fill them in before running.
 *
 *   fillCommand('scontrol show job <JOB_ID>', { data: { job_id: 142064 }}) →
 *     'scontrol show job 142064'
 *   fillCommand('ssh <NODE> "dmesg"', { data: {} }) →
 *     'ssh <NODE> "dmesg"'   // unchanged, user must substitute
 */
export function fillCommand(template: string, ctx: CheatsheetCtx): string {
  const d = ctx.data ?? {};
  const table: Record<string, string | undefined> = {
    NODE: d.node,
    GPU_IDX: d.gpu_idx !== undefined ? String(d.gpu_idx) : undefined,
    GPU_ID: d.gpu_id,
    JOB_ID: d.job_id !== undefined ? String(d.job_id) : undefined,
    USER: d.user,
    PARTITION: d.partition,
    HCA: d.hca,
    PORT: d.port !== undefined ? String(d.port) : undefined,
    LID: d.lid,
    CODE: d.xid_code !== undefined ? String(d.xid_code) : undefined,
    BMC_IP: d.bmc_ip,
  };
  return template.replace(/<([A-Z_]+)>/g, (match, key: string) => {
    const v = table[key];
    return v !== undefined && v !== "" ? v : match;
  });
}
